import React from 'react';
import { Colors } from '../../ui';
import { TableButton, TableButtonProps } from '../../ui/TableButton';
import { Avatar } from './Avatar';
import { AvatarStripItem } from './AvatarStrip';

export type AvatarTableButtonProps = TableButtonProps & {
    value?: AvatarStripItem,
    placeholder?: string,
    onAction?: () => void,
    children?: React.ReactNode,
};

export const AvatarTableButton = ({ active, disabled, variant, value, placeholder, onAction, children }: AvatarTableButtonProps) => {
    return <TableButton active={active} variant={variant} onClick={onAction}>
        {value && <Avatar variant={variant} size="1.75" name={value.name} photo={value.photo} color={value.color} />}
        {!value && <Avatar variant={variant} size="1.75" color={Colors.primaryLight}>?</Avatar>}
        <span>{value?.name ?? placeholder ?? 'Unassigned'}</span>
        {children}
    </TableButton>;
};
